import { provideHttpClient, withInterceptorsFromDi } from '@angular/common/http';
import { ErrorHandler, NgModule, isDevMode } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { providePrimeNG } from 'primeng/config';
import Aura from '@primeng/themes/aura';

import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { ServiceWorkerModule } from '@angular/service-worker';
import { MessageService, ConfirmationService } from 'primeng/api';


import { environment } from '../environments/environment';
import { SharedModule } from './shared/shared.module';
import { CoreModule } from './core/core.module';
import { ApiModule } from './core/api/api.module';
import { MainModule } from './main/main.module';
import { ClientsModule } from './clients/clients.module';
import { SupportModule } from './support/support.module';
import { DeveloperModule } from './developer/developer.module';
import { MarketingModule } from './marketing/marketing.module';
import { AdminModule } from './admin/admin.module';

@NgModule({
  declarations: [
    AppComponent],
  imports: [
    BrowserModule,
    BrowserAnimationsModule,
    SharedModule.forRoot(),
    ApiModule.forRoot({
      rootUrl: environment.webApiRoot,
    }),
    AppRoutingModule,
    ServiceWorkerModule.register('ngsw-worker.js', {
      enabled: !isDevMode(),
      // Register the ServiceWorker as soon as the application is stable
      // or after 30 seconds (whichever comes first).
      registrationStrategy: 'registerWhenStable:30000',
    }),
    CoreModule.forRoot(),
    MainModule,
    ClientsModule,
    SupportModule,
    DeveloperModule,
    MarketingModule,
    AdminModule
  ],
  providers: [
    MessageService,
    ConfirmationService,
    provideHttpClient(withInterceptorsFromDi()),
    providePrimeNG({
      theme: {
        preset: Aura,
        options: {
          darkModeSelector: 'none'
        }
      }
    })
  ],
  bootstrap: [AppComponent],
})
export class AppModule { }
